<script setup lang="ts">
    import { toRefs } from "vue";
    import KCell from "@/components/KTable/KCell.vue";
    import StatusInaktivIcon from "@/assets/actionIcons/statusinaktiv.svg";
    import IconLabel from "@/components/IconLabel.vue";

    const props = defineProps<{
        data: boolean;
    }>();

    const { data } = toRefs(props);
</script>

<template>
    <KCell class="cell-inaktiv">
        <template #content>
            <IconLabel v-if="data === false" :icon="StatusInaktivIcon" text="Inaktiv" />
        </template>
    </KCell>
</template>

<style lang="scss">
    .cell-inaktiv {
        .icon-label {
            display: flex;
            gap: 4px;
            justify-items: center;
        }
    }
</style>
